import { Stack, styled } from "@mui/material";
import { actionBarName } from "../classes.js";
const Root = styled(Stack, {
  name: actionBarName,
  slot: "Root",
  shouldForwardProp: (prop) => prop !== "ownerState",
  overridesResolver: (props, styles) => {
    const { ownerState } = props;
    return [styles.root, ownerState?.size && styles[ownerState.size]];
  }
})`
  flex-direction: row;
`;
export {
  Root
};
//# sourceMappingURL=Root.js.map
